<div class="text-center" [innerHTML]="version"></div>
